import { render, staticRenderFns } from "./DataPage.vue?vue&type=template&id=528b5c03&scoped=true&"
import script from "./DataPage.vue?vue&type=script&lang=js&"
export * from "./DataPage.vue?vue&type=script&lang=js&"
import style0 from "./DataPage.vue?vue&type=style&index=0&id=528b5c03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528b5c03",
  null
  
)

export default component.exports